import {
  fetchCertainPaymentMethodEpic,
  PAYMENT_METHODS_FEATURE_KEY,
  paymentMethodsReducer,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

import { PaymentProcessing as PaymentProcessingV1 } from './lib/v1';
import { PaymentProcessing as PaymentProcessingV2 } from './lib/v2';
import { PaymentProcessing as PaymentProcessingV3 } from './lib/v3';

export const PaymentProcessingFeature = createFeature({
  component: {
    PaymentProcessingV1,
    PaymentProcessingV2,
    PaymentProcessingV3,
  },

  hook: {},

  store: {
    epics: [fetchCertainPaymentMethodEpic],

    middlewares: [],

    reducerMap: {
      [PAYMENT_METHODS_FEATURE_KEY]: paymentMethodsReducer,
    },
  },
});
